const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function mountReveal(root) {
	const elements = [...root.querySelectorAll("[data-reveal]")];
	if (!elements.length) return () => {};

	const showAll = () => {
		elements.forEach((element) => element.classList.add("is-visible"));
	};

	if (reducedMotion() || window.innerWidth < 768 || !("IntersectionObserver" in window)) {
		showAll();
		return () => {};
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				entry.target.classList.add("is-visible");
				observer.unobserve(entry.target);
			});
		},
		{ threshold: 0.08, rootMargin: "0px 0px -30px 0px" },
	);

	elements.forEach((element) => {
		observer.observe(element);
	});

	window.addEventListener("pageshow", showAll);
	const safetyTimer = setTimeout(showAll, 4000);

	return () => {
		clearTimeout(safetyTimer);
		observer.disconnect();
		window.removeEventListener("pageshow", showAll);
	};
}
